import { HttpClinet, baseURL, version } from './../utils/config'

export const userAPI = {
    getUserSetting: () => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/user/getUserSetting`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    getUserRetail: () => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/user/getUserRetail`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    getUserByID: (_id) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/user/getUserByID/${_id}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    Register: (data) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/user/register`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/form-data',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    editUserDetail: (data) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/user/editUserDetail`,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/form-data',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    }
}